import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { MaskLogo, InstagramIcon, FacebookIcon, LinkedinIcon } from "./Mask";
import { CONTACT } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative z-10 mt-[-2rem] rounded-t-[2.5rem] bg-koreyaah-cobalt text-koreyaah-cream pt-24 pb-10">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <MaskLogo className="h-10 w-auto" variant="white" />
              <span className="font-display text-3xl font-bold">Koreyaah</span>
            </div>
            <p className="mt-4 text-sm text-koreyaah-cream/70 leading-relaxed">
              Your daily dose of Seoul — authentic Korean street food with Indian warmth.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={CONTACT.social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="grid h-11 w-11 place-items-center rounded-full bg-koreyaah-cream/10 text-koreyaah-cream transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-[#E1306C]">
                <InstagramIcon size={18} />
              </a>
              <a href={CONTACT.social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="grid h-11 w-11 place-items-center rounded-full bg-koreyaah-cream/10 text-koreyaah-cream transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-[#1877F2]">
                <FacebookIcon size={18} />
              </a>
              <a href={CONTACT.social.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="grid h-11 w-11 place-items-center rounded-full bg-koreyaah-cream/10 text-koreyaah-cream transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-[#0A66C2]">
                <LinkedinIcon size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-koreyaah-cream/75">
              <li><Link to="/" className="hover:text-koreyaah-red transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-koreyaah-red transition-colors">About Us</Link></li>
              <li><Link to="/menu" className="hover:text-koreyaah-red transition-colors">Menu</Link></li>
              <li><Link to="/franchise" className="hover:text-koreyaah-red transition-colors">Franchise</Link></li>
              <li><Link to="/contact" className="hover:text-koreyaah-red transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-koreyaah-cream/75">
              <li className="flex gap-3"><MapPin size={18} className="shrink-0 text-koreyaah-red" /><span>2 outlets — Sarjapur (Natura Walk) & Begur (The Hub), Bengaluru</span></li>
              <li className="flex gap-3"><Phone size={18} className="shrink-0 text-koreyaah-red" /><a href={`tel:${CONTACT.phoneLink}`} className="hover:text-koreyaah-red">{CONTACT.phone}</a></li>
              <li className="flex gap-3"><Mail size={18} className="shrink-0 text-koreyaah-red" /><a href={`mailto:${CONTACT.email}`} className="hover:text-koreyaah-red">{CONTACT.email}</a></li>
              <li className="flex gap-3"><Clock size={18} className="shrink-0 text-koreyaah-red" /><span>{CONTACT.hours}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-koreyaah-cream/75">
              <li><Link to="/privacy" className="hover:text-koreyaah-red transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-koreyaah-red transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-koreyaah-cream/15 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-koreyaah-cream/60">
          <p>© {new Date().getFullYear()} Koreyaah. All rights reserved.</p>
          <p className="uppercase tracking-widest">Korean Street Food · Bengaluru</p>
        </div>
      </div>
    </footer>
  );
}
